import Svg from 'components/utilities/svg'

// SVG from Google Material design stacks_24dp_E8EAED_FILL0_wght400_GRAD0_opsz24
const StacksIcon = ({ ...props }) => (
  <Svg viewBox="0 -960 960 960" {...props}>
    <title>Stacks Icon</title>
    <path d="M480-400 40-640l440-240 440 240-440 240Zm0 160L63-467l84-46 333 182 333-182 84 46-417 227Zm0 160L63-307l84-46 333 182 333-182 84 46L480-80Zm0-411 273-149-273-149-273 149 273 149Zm0-149Z" />
  </Svg>
)

StacksIcon.displayName = 'Stacks'

export default StacksIcon
